export default {"src":"/_next/static/media/reserveIcon.2ae90c7a.svg","height":31,"width":28,"blurWidth":0,"blurHeight":0};